@if (progress.progressSpinner$ | async) {
  <div class="spinner-overlay">
    <mat-progress-spinner
      mode="indeterminate"
      strokeWidth="3"
      [diameter]="80"
    ></mat-progress-spinner>
  </div>
}
